import React from "react";
import createReactClass from "create-react-class";
import compressImage from "../../lib/image_compressor";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      uploadingPhoto: false,
      file: {},
    };
  },
  handleSubmit(e) {
    e.preventDefault();
    $("#ta-message").css("height", "34px");

    var body = this.body.value.trim();

    if (!body) {
      return;
    }

    this.props.onMessageSubmit({ body: body });
    this.body.value = "";
    $(".flexNewMessage").innerHeight($("#ta-message").innerHeight());
    return;
  },
  onFocus() {
    if (window.innerWidth > 767) {
      // PC
      this.props.pauseLoading();
    } else {
      this.props.pauseLoading();
      $("#new-message-wrap").css({ "padding-bottom": "50px" });
    }
  },
  onBlur() {
    if (window.innerWidth > 767) {
      // PC
      this.props.startLoading();
    } else {
      this.props.startLoading();
      $("#new-message-wrap").css({ "padding-bottom": "10px" });
    }
  },
  onChange(e) {
    var lineHeight = Number(
      $(e.target)
        .css("lineHeight")
        .split("px")[0]
    );

    let prevTargetScrollHeight;
    if (prevTargetScrollHeight === undefined) {
      prevTargetScrollHeight = e.target.scrollHeight;
    }
    // eslint-disable-next-line no-constant-condition
    while (true) {
      $(e.target).height($(e.target).height() - lineHeight);
      if (e.target.scrollHeight > e.target.offsetHeight) {
        $(e.target).height(e.target.scrollHeight - 12);

        if (window.innerWidth > 767) {
          // PC
          var blockMessageListInner = $(".block-messageListInner");
          var blockMessageList = $(".block-messageList");
          var scrolled = blockMessageList.scrollTop();
          blockMessageListInner.css(
            "padding-bottom",
            80 + e.target.scrollHeight
          );
          if (prevTargetScrollHeight !== e.target.scrollHeight) {
            blockMessageList.scrollTop(
              scrolled + e.target.scrollHeight - prevTargetScrollHeight
            );
          }
          prevTargetScrollHeight = e.target.scrollHeight;
        } else {
          // スマホ
          $(".flexNewMessage").innerHeight($("#ta-message").innerHeight());
          if (prevTargetScrollHeight !== e.target.scrollHeight) {
            // 以前と入力欄の行の高さが異なる時に走る
            // コンテントメッセージ（メッセージの塊を最上部に移動させる）
            $(".containerMessage").scrollTop(
              $(".containerMessage").scrollTop() +
                e.target.scrollHeight -
                prevTargetScrollHeight
            );
          }
          // 入力欄の高さ
          prevTargetScrollHeight = e.target.scrollHeight;
        }

        break;
      }
    }
  },
  onKeyDown(e) {
    var height = Number(
      $(e.target)
        .css("height")
        .split("px")[0]
    );
    e.keyCode === 13 && height < 108
      ? this.props.setMessageListPadding(height - 10)
      : this.props.setMessageListPadding(height - 34);

    // リターンキーで送信
    if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) {
      if (e.keyCode === 13) {
        this.handleSubmit(e);
        return false;
      }
    }
  },
  async handlePhotoInput(e) {
    var file = e.target.files[0];
    file = await compressImage(file);
    this.props.setFile(file);
    this.props.openModal();
  },
  render() {
    // const balloon = this.props.isBalloonDisp ? (
    //   <div className="proposal-template-message">
    //     <div className="balloon">
    //       <p>
    //         【サークル名】に参加しました。<br />簡単メッセージ作成機能を利用して自己紹介しよう！
    //       </p>
    //       <div className="button-box mt20">
    //         <button className="no-button">いいえ</button>
    //         <button className="yes-button">
    //           <a href="/template_message/select">はい</a>
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // ) : (
    //   ""
    // );
    //const join_message = : '';
    if (this.props.isSendDisabled) {
      return (
        <div className="fixed-bottom bg-graydark">
          <div className="container col-md-8 col-lg-6 pr-0">
            <div className="pt-3 pb-3 text-center text-muted" style={{ fontSize: '14px' }}>
              メッセージの送信期限が過ぎたため、送信できません。
            </div>
          </div>
        </div>
      );
    }

    return (
      // <div id="new-message-wrap" className="block-new-message-wrap flexNewMessage flexNewMessageOverTabbar sp-relative">
      //   {balloon}
      //   <form className="new_message" id="new_message">
      //     <label htmlFor="message-photo" style={{fontSize:"20px", margin:"0 10px -5px 5px"}}>
      //       <i className="fas fa-image"></i>
      //       <input type="file" id="message-photo" style={{display:"none"}} onChange={(e) => this.handlePhotoInput(e)} disabled={this.state.uploadingPhoto} />
      //     </label>
      //     {
      //       window.innerWidth > 767
      //       ? <textarea
      //       ref="body"
      //       className="form-control message-textarea"
      //       id="ta-message"
      //       placeholder="メッセージ"
      //       onFocus={this.onFocus}
      //       onBlur={this.onBlur}
      //       onChange={this.onChange}
      //       onKeyDown={this.onKeyDown} />
      //       : <textarea
      //       ref="body"
      //       className="form-control message-textarea"
      //       id="ta-message"
      //       placeholder="メッセージ"
      //       onFocus={this.onFocus}
      //       onBlur={this.onBlur}
      //       onChange={this.onChange}
      //       onKeyDown={this.onKeyDown}
      //       style={{marginLeft: "25px"}} />
      //     }
      //     <button id="btnMessageSubmit" className="btn btn-message-submit" onClick={this.handleSubmit}>
      //       <i className="fas fa-paper-plane icon-message-submit"></i>
      //     </button>
      //   </form>
      // </div>
      <div className="fixed-bottom bg-graydark">
        <div className="container col-md-8 col-lg-6 pr-0">
          {this.props.isBlocking ? (
            <div className="input-group pt-2 pb-2 justify-content-center">
              <p className="text-muted mb-0 py-2" style={{ fontSize: "0.9em" }}>
                ブロックしています
              </p>
            </div>
          ) : (
            <div className="input-group pt-2 pb-2">
              <div className="input-group-append p-0">
                <label htmlFor="message-photo" className="mt-1 pr-2">
                  <img
                    src="/assets2019/img/icon_camera.svg"
                    alt=""
                    className="icon--camera"
                  />
                  <input
                    type="file"
                    id="message-photo"
                    style={{ display: "none" }}
                    onChange={(e) => this.handlePhotoInput(e)}
                    disabled={this.state.uploadingPhoto}
                  />
                </label>
              </div>
              <textarea
                ref={(c) => {
                  this.body = c;
                }}
                className="form-control border-0 rounded h-1em"
                row="1"
                col="1"
                id="ta-message"
                placeholder="メッセージ"
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                style={{ maxHeight: 108 }}
              />
              <div className="input-group-append">
                <button
                  id="btnMessageSubmit"
                  className="btn text-black-50 text-fw-bold"
                  onClick={this.handleSubmit}
                >
                  送信
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  },
});
